import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Browserslist UI", -1)
const _hoisted_2 = { class: "query" }
const _hoisted_3 = { class: "input" }
const _hoisted_4 = { for: "userInput" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 🔍 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("a", { href: "https://github.com/browserslist/browserslist#query-composition" }, " Browserslist query ", -1)
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("h1", null, "Desktop Browsers", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("h1", null, "Mobile Browsers", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", null, "Source"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("a", { href: "https://github.com/DamianOsipiuk/browserslist-ui" }, "GitHub")
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("a", { href: "https://github.com/browserslist/browserslist" }, "Browserslist")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("a", { href: "https://github.com/ben-eb/caniuse-lite" }, "caniuse-lite")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Progress = _resolveComponent("Progress")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.updateExists)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "update-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshApp && _ctx.refreshApp(...args)))
        }, " New version available! Click to update. "))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("input", {
          id: "userInput",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.appendQueryToUrl && _ctx.appendQueryToUrl(...args))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.browserString = $event))
        }, null, 544), [
          [_vModelText, _ctx.browserString]
        ]),
        _createVNode("label", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.queryError)
            ? (_openBlock(), _createBlock("span", _hoisted_7, "❗ Invalid query"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_Progress, { value: _ctx.totalCoverage }, null, 8, ["value"]),
    _createVNode("main", null, [
      _createVNode("section", null, [
        _hoisted_8,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.desktopBrowsers, (browser) => {
          return (_openBlock(), _createBlock(_component_Table, {
            key: browser.name,
            browser: browser
          }, null, 8, ["browser"]))
        }), 128))
      ]),
      _createVNode("section", null, [
        _hoisted_9,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mobileBrowsers, (browser) => {
          return (_openBlock(), _createBlock(_component_Table, {
            key: browser.name,
            browser: browser
          }, null, 8, ["browser"]))
        }), 128))
      ])
    ]),
    _createVNode("footer", null, [
      _hoisted_10,
      _createVNode("div", null, [
        _hoisted_11,
        _createVNode("p", null, _toDisplayString(_ctx.versions.browserslist), 1)
      ]),
      _createVNode("div", null, [
        _hoisted_12,
        _createVNode("p", null, _toDisplayString(_ctx.versions.caniuse), 1)
      ])
    ])
  ], 64))
}